import { useAuth } from "@/components/auth/AuthProvider";
import { LoggedInHero } from "./LoggedInHero";
import { HeroSection } from "../hero/HeroSection";

export function Hero() {
  const { user } = useAuth();

  if (user) {
    return <LoggedInHero />;
  }

  return (
    <section className="relative flex flex-col items-center justify-center w-full">
      <div className="relative z-10 w-full">
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <HeroSection />
        </div>
      </div>
    </section>
  );
}